import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { ApiResponse } from '../models/api-resoponse';

export interface CharityAgreementView {
  has_agreement: boolean;
  created_on: string;
  charity_user: string;
}

export interface CharityAgreementSignRequest {
  has_agreement: boolean;
}

@Injectable({ providedIn: 'root' })
export class CharityAgreementService {
  private readonly apiBaseUrl = environment.baseApi;
  private readonly httpClient = inject(HttpClient);
  
  private agreementSignedSubject = new Subject<void>();
  agreementSigned$ = this.agreementSignedSubject.asObservable();

  getAgreement(charityId: string): Observable<ApiResponse<CharityAgreementView>> {
    return this.httpClient.get<ApiResponse<CharityAgreementView>>(
      `${this.apiBaseUrl}charity-user/charity/${charityId}/profile/agreement/`
    );
  }

  signAgreement(charityId: string, data: CharityAgreementSignRequest): Observable<ApiResponse<any>> {
    return this.httpClient.post<ApiResponse<any>>(
      `${this.apiBaseUrl}charity-user/charity/${charityId}/profile/agreement/sign/`,
      data
    );
  }
  
  notifyAgreementSigned(): void {
    this.agreementSignedSubject.next();
  }
}
